import qs from "query-string";
import { setSentryCatchOnRequest } from "./sentryEvent";
require("es6-promise").polyfill();
require("isomorphic-fetch");

export enum FetchType {
	GET = "GET",
	POST = "POST",
}

function checkStatus(response: Response): Response {
	if (!response.ok || response.status !== 200) {
		console.error("error:", response);
		setSentryCatchOnRequest({
			error: `${response.status}, ${response.statusText}`,
			request: response.url,
		});
		throw `${response.status}, ${response.statusText}`;
	}
	return response;
}

export interface Options {
	apiDomain?: string;
	cookie?: string;
	statsdKey?: string;
	headers?: { [key: string]: any };
	fetchMethod?: FetchType;
}

function webapi<T>(
	method: string,
	params: any,
	{ apiDomain, cookie, statsdKey, headers, fetchMethod = FetchType.POST }: Options = {},
): Promise<T> {
	const isProtobufMethod = method.includes("/");
	const webapiAddress = apiDomain;
	let url = `${webapiAddress}/${isProtobufMethod ? method : method.replace(/\./g, "/")}`;
	url = method ? url : `${apiDomain}${method}`;
	let init: RequestInit = {
		method: fetchMethod,
		headers: {
			cookie,
			...headers,
		},
	};
	if (fetchMethod.toLocaleUpperCase() === FetchType.GET) {
		url = `${url}?${qs.stringify(params)}`;
	}
	if (fetchMethod.toLocaleUpperCase() === FetchType.POST) {
		init = {
			...init,
			credentials: "include",
			body: JSON.stringify(params),
		};
	}
	let statsDClientSub;
	if (__SERVER__) {
		const { statsDClient } = require("ez-node-monitor");
		statsDClientSub = statsDClient;
	}
	const startTime = Date.now();

	return fetch(url, init)
		.then(checkStatus)
		.then((response) => {
			statsDClientSub && statsDClientSub.statsd_api_timing(statsdKey || method, startTime);
			return response.json() as Promise<T>;
		})
		.catch((error) => {
			statsDClientSub && statsDClientSub.statsd_api_failure(statsdKey || method);
			setSentryCatchOnRequest({
				error,
				request: url,
			});
			throw error;
		});
}

export default webapi;
